export enum SaleType {
    STANDARD = "STANDARD",
    OFFER = "OFFER",
    AUCTION = "AUCTION"
}
